import * as React from 'react'
import classNames from 'classnames'
import { Loader } from '../Form/Loader'

export const ReservationButton = ({
  id,
  loading = false,
  disabled = false,
  children,
  onClick,
}: {
  id?: string
  loading?: boolean
  disabled: boolean
  children: React.ReactNode
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}) => (
  <button
    type="submit"
    id={id}
    className={classNames(
      'flex items-center justify-center font-europa-yu font-bold rounded text-white cursor-pointer',
      'desktop:w-[327px] desktop:h-[60px] desktop:hover:opacity-80',
      'sp:w-[325px] sp:h-[53px]',
      disabled ? 'bg-bg-gray-0 pointer-events-none' : 'bg-text-black'
    )}
    disabled={disabled}
    onClick={!loading && !disabled ? onClick : () => ({})}
  >
    {loading ? <Loader /> : children}
  </button>
)
